import {createSharedComposable, useBreakpoints} from '@vueuse/core';
import {computed} from 'vue';
import {BREAKPOINTS} from '../config/breakpoints';

// createSharedComposable will create only a single instance of the composable
// across all components that use it, which is a bit useful for performance and memory usage,
// since breakpoints are used in many components.

export const useBreakpoint = createSharedComposable(() => {
    const breakpoints = useBreakpoints(BREAKPOINTS);

    const breakpointSmAndGreater = computed(() => breakpoints.greaterOrEqual('sm').value ?? false);

    const breakpointMdAndGreater = computed(() => breakpoints.greaterOrEqual('md').value ?? false);

    const breakpointLgAndGreater = computed(() => breakpoints.greaterOrEqual('lg').value ?? false);

    const breakpoint2XlAndGreater = computed(
        () => breakpoints.greaterOrEqual('2xl').value ?? false
    );

    const breakpoint3XlAndGreater = computed(
        () => breakpoints.greaterOrEqual('3xl').value ?? false
    );

    const breakpointXlAndGreater = computed(() => breakpoints.greaterOrEqual('xl').value ?? false);

    const isMobile = computed(() => !breakpointLgAndGreater.value);

    return {
        breakpointSmAndGreater,
        breakpointMdAndGreater,
        breakpointLgAndGreater,
        breakpoint2XlAndGreater,
        breakpoint3XlAndGreater,
        breakpointXlAndGreater,
        isMobile,
    };
});
